import { render, staticRenderFns } from "./EdlordersCancelModal.vue?vue&type=template&id=40553d94&"
import script from "./EdlordersCancelModal.vue?vue&type=script&lang=js&"
export * from "./EdlordersCancelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports